import './App.css';

import { BrowserRouter, Navigate, Routes, Route, useLocation } from "react-router-dom";
import FunVizTabs from './components/FunViz/FunVizTabs';
import Analysis from './components/Analysis/Analysis';
import Screener from './components/Screener/Screener';
import Landing from "./components/Landing/Landing";
import MarketHealth from './components/MarketHealth/MarketHealth';
import BlogPage from './components/Blog/BlogPage';
import Layout from "./components/Layout/Layout";
import TermsOfService from "./components/Legal/TermsOfService";
import PrivacyPolicy from "./components/Legal/PrivacyPolicy";
import Disclaimer from "./components/Legal/Disclaimer";
import NoPage from "./components/NoPage/NoPage";

// Routing: the root path is a small landing page; the app proper lives under
// the FunVizTabs shell at /analysis (the Analysis view), /screener, and
// /markethealth. Standalone pages — legal (/terms, /privacy, /disclaimer)
// and the research /blog — live outside the FunVizTabs shell, since they
// aren't app tabs. All routes share the Layout top bar (logo + brand + mock
// account menu) and the legal footer via <Outlet />.
//
// /funviz was the Analysis URL until the app moved to /analysis. Bookmarks
// and shared links still use it, so send that prefix to the current routes
// and keep any query string or hash (?symbol=, #…).
function LegacyFunvizRedirect() {
  const { pathname, search, hash } = useLocation();
  const rest = pathname.replace(/^\/funviz\/?/i, "").replace(/\/$/, "");
  const segment = rest.toLowerCase();
  let target = "/analysis";
  if (segment === "screener") target = "/screener";
  else if (segment === "markethealth") target = "/markethealth";
  return <Navigate to={`${target}${search}${hash}`} replace />;
}

function App() {
  return (
    <div className="wrapper">
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Landing />} />
          <Route element={<FunVizTabs />}>
            <Route path="analysis" element={<Analysis />} />
            <Route path="screener" element={<Screener />} />
            <Route path="markethealth" element={<MarketHealth />} />
          </Route>
          {/* Standalone legal + research pages: under Layout (so they share
              the top bar and legal footer) but outside the FunVizTabs shell,
              since they are not app tabs. */}
          <Route path="terms" element={<TermsOfService />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route path="disclaimer" element={<Disclaimer />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="funviz" element={<LegacyFunvizRedirect />} />
          <Route path="funviz/*" element={<LegacyFunvizRedirect />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
    </div>
  );
}


export default App;
